/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Status_ChangeInputs */

const cs_enum_status_change = /** @type {(inputs: Enum_Status_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změna stavu`)
};

const en_enum_status_change = /** @type {(inputs: Enum_Status_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status change`)
};

/**
* | output |
* | --- |
* | "Status change" |
*
* @param {Enum_Status_ChangeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_status_change = /** @type {((inputs?: Enum_Status_ChangeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Status_ChangeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_status_change(inputs)
	return cs_enum_status_change(inputs)
});